(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["fc-age-gate"] && !Shopify.designMode) return;
  try {
    (() => {
    const dialog = document.getElementById('fc-age-gate');
    if (!dialog) return;
    const key = 'erecta-age-confirmed-v1';
    let state = null;
    try { state = sessionStorage.getItem(key); } catch {}
    const save = value => { state = value; try { sessionStorage.setItem(key, value); } catch {} };
    const reject = () => {
      dialog.querySelector('[data-age-prompt]').hidden = true;
      dialog.querySelector('[data-age-denied]').hidden = false;
      dialog.setAttribute('aria-labelledby', 'fc-age-denied-title');
      dialog.setAttribute('aria-describedby', 'fc-age-denied-description');
      dialog.querySelector('#fc-age-denied-title').focus();
    };
    const open = () => {
      if (state === 'yes') return;
      document.documentElement.classList.add('fc-age-pending');
      if (!dialog.open) dialog.showModal();
      if (state === 'no') reject();
    };
    dialog.addEventListener('cancel', event => event.preventDefault());
    dialog.addEventListener('close', () => { if (state !== 'yes') open(); });
    dialog.querySelector('[data-age-accept]').addEventListener('click', () => {
      save('yes');
      document.documentElement.classList.remove('fc-age-pending');
      dialog.close();
      document.getElementById('MainContent')?.focus({ preventScroll: true });
    });
    dialog.querySelector('[data-age-reject]').addEventListener('click', () => { save('no'); reject(); });
    dialog.querySelector('[data-age-exit]').addEventListener('click', () => window.location.replace('about:blank'));
    window.addEventListener('pageshow', () => {
      try { state = sessionStorage.getItem(key); } catch {}
      if (state === 'yes') {
        document.documentElement.classList.remove('fc-age-pending');
        if (dialog.open) dialog.close();
      } else open();
    });
    if (state === 'yes') document.documentElement.classList.remove('fc-age-pending');
    else open();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["fc-erecta-navigation"] && !Shopify.designMode) return;
  try {
    (() => {
 const key='fc-erecta-scheme';
 let scheme=document.documentElement.dataset.fcScheme==='light'?'light':'dark';
 const apply=()=>{
  document.documentElement.dataset.fcScheme=scheme;
  document.documentElement.style.colorScheme=scheme;
  document.querySelectorAll('.fc-erecta[data-fc-scheme]').forEach(el=>{el.dataset.fcScheme=scheme;});
  document.querySelectorAll('[data-fc-theme]').forEach(el=>el.setAttribute('aria-pressed',String(el.dataset.fcTheme===scheme)));
 };
 document.addEventListener('click',e=>{
  const button=e.target.closest('[data-fc-theme]');
  if(button){scheme=button.dataset.fcTheme==='light'?'light':'dark';apply();try{localStorage.setItem(key,scheme);}catch{}}
  if(e.target.closest('.fc-site-mobile-nav a'))document.querySelector('.fc-site-menu')?.removeAttribute('open');
 });
 document.addEventListener('keydown',e=>{if(e.key==='Escape')document.querySelector('.fc-site-menu')?.removeAttribute('open');});
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',apply);else apply();
 document.addEventListener('shopify:section:load',apply);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["fc-iba-modal"] && !Shopify.designMode) return;
  try {
    (() => {
    const dialog = document.getElementById('fc-iba-modal');
    if (!dialog || typeof dialog.showModal !== 'function') return;
    let opener;
    let bodyOverflow;
    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-fc-iba]');
      if (!trigger || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      if (dialog.open) return;
      opener = trigger;
      bodyOverflow = document.body.style.overflow;
      dialog.showModal();
      document.body.style.overflow = 'hidden';
    });
    dialog.querySelector('[data-fc-iba-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', (event) => {
      if (event.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    });
    dialog.addEventListener('close', () => {
      document.body.style.overflow = bodyOverflow;
      if (opener && opener.isConnected) opener.focus({ preventScroll: true });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
